import { FC, useCallback } from 'react';
import { useBooking, useDialog } from '@/logic/state';

import shallow from 'zustand/shallow';
import { useQueryClient } from '@tanstack/react-query';
import { InfoDialog } from '@/components/shared/info-dialog';

export const ReservedSeatsInfoDialog: FC = () => {
  const setDialog = useDialog(s => s.setDialog, shallow);
  const [booking, setBooking] = useBooking(s => [s.booking, s.setBooking], shallow);

  const queryClient = useQueryClient();

  const handleOkayClick = useCallback(() => {
    setDialog({});
    setBooking(prevState => ({
      ...prevState,
      selectedTickets: prevState?.selectedTickets?.map(selectedTicket => ({
        ...selectedTicket,
        seats: [],
      })),
    }));

    queryClient.invalidateQueries([
      {
        method: 'get',
        url: 'showtimes/:sessionId/seats',
        query: {
          sessionId: booking?.sessionId,
        },
        params: {
          orderId: booking?.orderId,
        },
      },
    ]);
  }, [booking, queryClient, setBooking, setDialog]);

  return (
    <InfoDialog
      buttonId='reserved-seats-info-dialog'
      img='/icons/booking/reserved-seats-icon.svg'
      title='booking.reserved_seats_info_dialog.title'
      description='booking.reserved_seats_info_dialog.description'
      handleOkayClick={handleOkayClick}
    />
  );
};
